import { checkoutSteps } from './checkoutSteps';

import { Step } from '../model/checkoutModel';

export const getIsCheckoutStep = (value?: string): value is Step => checkoutSteps.includes(value as never);
